export const orignalArtFileWidth = 3420;
export const orignalArtFileHeight = 4533;
export const heightInInches = 15.11;
export const widthInInches = 11.41;
export const pixelInInch = 96; 
